<template>
  <div :class="[`x2-17 poppins-normal-thunder-25px`, className || ``]">
    <div class="text-439">{{ text1730 }}</div>
    <div class="text-43-1">{{ text1729 }}</div>
  </div>
</template>

<script>
export default {
  name: "X2102",
  props: ["text1730", "text1729", "className"],
};
</script>

<style>
.x2-17 {
  display: flex;
  gap: 54px;
  margin-left: 67px;
  width: 478px;
}

.text-439 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 123px;
}

.text-43-1 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 297px;
}

.x2-17.x2-18,
.x2-17.x2-20 {
  gap: 42px;
}

.x2-17.x2-18 .text-439,
.x2-17.x2-20 .text-439 {
  width: 135px;
}
</style>
